const INBOUND = 0;
const OUTBOUND = 1;

export {
  INBOUND,
  OUTBOUND
}
